export default "__VITE_ASSET__1be07507__"